import classNames from 'classnames'
import React, { FC } from 'react'
import { ProductCard, ProductCardProps } from '../ProductCard'
import '@styles/LandscapeProductCard/style.css'

const LandscapeProductCard: FC<ProductCardProps> = props => (
  <ProductCard {...props} cardCss={classNames('landscape-card', props.cardCss)} />
)

export default LandscapeProductCard
